export default __webpack_public_path__ + "7b4efa59933b470e3776b60fd85d0da4.jpg";